import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { apiRoute } from "services";
import API from "services/lib/api";
import ErrorView from "components/ui/ErrorView/ErrorView";
import KeyPhrase from "./KeyPhrase/KeyPhrase";
import CannedResponse from "./CannedResponse/CannedResponse";
import Suggestions from "./Suggestions/Suggestions";
import { Loading } from "components/ui";
import { dataQueryStatus } from "utils";
import { getErrorMessage } from "utils/helper";
import { saveMssgTagDetails } from "store/modules/agentInbox/actions";

import "./CurrentMessageTag.scss";

const { IDLE, LOADING, ERROR, DATAMODE } = dataQueryStatus;

const CurrentMessageTag = ({
    selectedMssgTagId,
    selectedMssgTagDetails,
}) => {
    const [errorMssg, setErrMssg] = useState("");
    const [status, setStatus] = useState(selectedMssgTagDetails?.id ? DATAMODE : IDLE);

    const dispatch = useDispatch();

    const getMessageTagDetails = async (httpRequest) => {
        try {
            setStatus(LOADING);
            const url = apiRoute?.getMessageTag(selectedMssgTagId);

            const res = await API.get(url, {
                signal: httpRequest?.signal,
            });

            if (res.status === 200) {
                const { data } = res.data
                setStatus(DATAMODE);

                dispatch(saveMssgTagDetails(selectedMssgTagId, data))
            }
        } catch (err) {
            setStatus(ERROR);
            setErrMssg(getErrorMessage(err));
        }
    };

    useEffect(() => {
        let httpRequest = new AbortController();

        if (selectedMssgTagDetails?.id
            === undefined) {
            getMessageTagDetails(httpRequest);
        }


        return () => {
            httpRequest.abort();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMssgTagId]);

    const { keyPhrases, conversations, cannedResponses } =
        selectedMssgTagDetails || {};

    const renderCompBasedOnStage = () => {
        switch (status) {
            case IDLE:
                return "";

            case LOADING:
                return <Loading />;

            case DATAMODE:
                return (
                    <>
                        <KeyPhrase
                            keyPhrases={keyPhrases}
                            selectedMssgTagId={selectedMssgTagId}
                            handleSuccess={getMessageTagDetails}
                        />
                        <Suggestions conversations={conversations} />
                        <CannedResponse
                            cannedResponses={cannedResponses}
                            selectedMssgTagId={selectedMssgTagId}
                            handleSuccess={getMessageTagDetails}
                        />
                    </>
                );
            case ERROR:
                return (
                    <ErrorView
                        message={errorMssg}
                        handleRetry={getMessageTagDetails}
                    />
                );
            default:
                return "";
        }
    };

    return (
        <>
            <div className='tagging'>{renderCompBasedOnStage()}</div>
        </>
    );
};

CurrentMessageTag.prototypes = {
    selectedMssgTagId: PropTypes.string.isRequired,
};

export default CurrentMessageTag;
